// @ts-check
import React from 'react';

import ListItemIcon from '@liquidweb-dev/undercurrent/ListItemIcon';
import MenuItem from '@liquidweb-dev/undercurrent/MenuItem';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import { useAddFavorite } from 'modules/queries/account/user/stateData/useAdd';
import useStateDataListForKey from 'modules/queries/account/user/stateData/useListForKey';
import { useRemoveFavorite } from 'modules/queries/account/user/stateData/useRemove';
import StarIcon from '@liquidweb-dev/undercurrent/icons/lucide/Star';
import StarOffIcon from '@liquidweb-dev/undercurrent/icons/lucide/StarOff';

const SStar = () => (
	<StarIcon sx={(theme) => ({ height: theme.size.xS, width: theme.size.xS })} />
);

const SStarOff = () => (
	<StarOffIcon
		sx={(theme) => ({ height: theme.size.xS, width: theme.size.xS })}
	/>
);

/**
 * @param {object} props
 * @param {() => void} props.onClick
 * @param {string} props.favoritesDisplayName
 * @param {string} props.uniqId
 */
const FavoriteMenuItem = ({
	onClick = () => {},
	favoritesDisplayName,
	uniqId,
}) => {
	const { data, isLoading } = useStateDataListForKey({ key: 'favorites' });
	const { mutate: addFavorite } = useAddFavorite();
	const { mutate: removeFavorite } = useRemoveFavorite();

	const path = `/servers/${uniqId}`;
	const favorite = data?.data.find((fav) => fav.path === path);

	const handleClick = () => {
		onClick();

		if (favorite) {
			removeFavorite({ uuid: favorite.uuid });
		} else {
			addFavorite({
				path,
				displayName: favoritesDisplayName,
			});
		}
	};

	return (
		<MenuItem disabled={isLoading} onClick={handleClick}>
			<ListItemIcon>{favorite ? <SStarOff /> : <SStar />}</ListItemIcon>
			<Typography variant="label-lg">
				{favorite ? 'Unfavorite' : 'Favorite'}
			</Typography>
		</MenuItem>
	);
};

export default FavoriteMenuItem;
